module.exports = __webpack_public_path__ + "static/media/model4-video2.a43b5c1a.mp4";